module.exports = __webpack_public_path__ + "static/media/2DGACM3.9e6c4ea1.jpg";